module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_faq_remoteEntry_mjs_56556480__;